import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { GETEmployeeResponse, POSTEmployeeBody } from '@cbgms/api'
import { createEmployee, loadEmployeeSkills } from '../state/actions'
import EmployeeForm from './EmployeeForm'
import { useTranslation } from 'react-i18next'
import { CountryCode } from '@carsys/enums/country-code'
import { EmptyDate } from '@cbgms/base/utils/datetime'
import { useNotifier } from '@cbgms/base/notifier'

interface RoutePrams {
  companyUUID?: string
  shopID?: string
}

const NewEmployeeForm = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const notifier = useNotifier()
  const { companyUUID, shopID } = useParams<RoutePrams>()

  const redirectURL = React.useMemo(() => {
    if (shopID === 'new') {
      return `/companies/${companyUUID}/shops/new#employees`
    }
    return `/companies/${companyUUID}/shops/edit/${shopID}#employees`
  }, [shopID])

  useEffect(() => {
    if (companyUUID) {
      dispatch(loadEmployeeSkills(companyUUID))
    }
  }, [companyUUID])

  const onSubmit = async (values: any) => {
    try {
      const data: POSTEmployeeBody<'support'> = {
        ...values,
        CompanyUUID: companyUUID,
        CurrentShop: shopID
      }

      const { Data } = (await dispatch(createEmployee(data))) as any as GETEmployeeResponse<'support'>

      return `/companies/${companyUUID}/shops/${shopID}/employees/edit/${Data.UUID}`
    } catch (error) {
      throw error
    }
  }

  const onSubmitAndDone = async (values: any) => {
    try {
      const data = {
        ...values,
        CompanyUUID: companyUUID,
        CurrentShop: shopID
      }

      await dispatch(createEmployee(data))

      return redirectURL
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async () => {
    notifier.success(t('setting_employee.successfully_created'))
  }

  const initialValues = {
    VisitorCountry: '' as CountryCode,
    PostalCountry: '' as CountryCode,
    Skills: [],
    Functions: [],
    DateOfBirth: EmptyDate,
    DateInService: EmptyDate,
    DateOutOfService: EmptyDate,
    IsShopDefault: true
  }

  return (
    <EmployeeForm
      form='employee_new'
      hideUser
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      onSubmitAndDone={onSubmitAndDone}
      redirectToURL={redirectURL}
    />
  )
}

export default NewEmployeeForm
